import { call, put } from 'redux-saga/effects';
import axios from 'axios';

import * as actions from '../actions/index';
import { alertDialogSetSaga } from './alertDialog';

import { getSessionToken } from '../../constants/session';

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const resource = process.env.REACT_APP_PAYMENTS_WORKING_CAPITAL_ACCEPTANCE;

/**
 * POSTs the payee's response to a working capital offer. The caller is resolved
 * server-side from the bearer claims, so only the offer terms travel in the body.
 *
 * An `acceptedAmount` of 0 denotes a rejection of the offer.
 */
export default function* postWorkingCapitalAcceptanceSaga(action) {
    const {
        offerId,
        acceptedAmount,
        acceptedHoldbackRate = null,
        acceptedNumOfRepayments = null,
        rejectionReason = null,
        disclosureValues = null,
    } = action.data ?? {};

    try {
        yield put(actions.workingCapitalAcceptanceStart(offerId));

        const url = baseUrl + resource;
        const sessionToken = getSessionToken();

        // The repayment fields are mutually exclusive (and both null on a
        // rejection), so drop whichever are null. `acceptedAmount` is 0 on a
        // rejection, which `!= null` correctly keeps. `rejectionReason` is only
        // present on a rejection and is dropped on an acceptance;
        // `disclosureValues` is the reverse.
        const body = Object.fromEntries(
            Object.entries({
                offerId,
                acceptedAmount,
                acceptedHoldbackRate,
                acceptedNumOfRepayments,
                rejectionReason,
                disclosureValues,
            }).filter(([, value]) => value != null),
        );

        const response = yield axios.post(url, JSON.stringify(body), {
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionToken,
            },
        });

        yield put(
            actions.workingCapitalAcceptanceSuccess(
                offerId,
                response.data.result ?? null,
            ),
        );
    } catch (error) {
        yield call(alertDialogSetSaga, {
            data: {
                open: true,
                severityLevel: 'error',
                message: error?.response?.data?.error ?? error?.message,
            },
        });
        yield put(
            actions.workingCapitalAcceptanceFail(
                offerId,
                error?.response?.data?.error ?? error?.message,
            ),
        );
    }
}
